import { AnimatePresence } from 'framer-motion'
import React, { useState } from 'react'
import EditCurrency from './EditCurrency'
import pen from '../../assets/icons/pen.svg'

const CurrencyRow = ({ currency, index, refresh }) => {
  const [edit, setEdit] = useState(false)
  function formatDate(dateString) {
    const options = { year: '2-digit', month: '2-digit', day: '2-digit' }
    const date = new Date(dateString)
    return date.toLocaleDateString('en-GB', options)
  }

  return (
    <>
      <div className={`${index % 2 === 0 ? '' : ' bg-gray/20'} flex py-2`}>
        <div className="flex-1 p-2 items-center justify-center flex">
          {currency.name || 'no name'}
        </div>
        <div className="flex-1 p-2 items-center justify-center flex">
          {currency.code}
        </div>
        <div className="flex-1 p-2 items-center justify-center flex">
          {currency.symbol || 'no symbol'}
        </div>
        <div className="flex-1 p-2 items-center justify-center flex">
          {currency.amount}
        </div>
        <div className="flex-1 flex p-2  items-center justify-center  ">
          {formatDate(currency.created_at)}
        </div>
        <div className="flex-1 p-2 items-center justify-center flex gap-3">
          <button
            onClick={() => setEdit(true)}
            className=" w-6 h-6 flex border-[1px] justify-center items-center rounded-sm border-darkBlue text-blueButton  p-1 aspect-square hover:bg-blue-600"
          >
            <span>
              <img src={pen} alt="" />
            </span>
          </button>
        </div>
      </div>
      <AnimatePresence>
        {edit && (
          <EditCurrency
            refresh={refresh}
            active={edit}
            close={() => setEdit(false)}
            currency={currency}
          />
        )}
      </AnimatePresence>
    </>
  )
}

export default CurrencyRow
